import '../styles/components/Pill.css'

interface PillProps {
    title: string
    targetUrl?: string
    colorClass?: string
}

export function Pill({
                         title = '',
                         targetUrl,
                         colorClass = 'region-europe'
                     }: PillProps) {

    {/*
        Possible Color Classes:
        region-europe
        region-asia
        region-africa
        region-america
    */}

    return (
        <>
            {
                targetUrl ? (
                    <a href={targetUrl} className={`pill ${colorClass}`}>
                        {title}
                    </a>
                ) : (
                    <span className={`pill ${colorClass}`}>
                    {title}
                </span>
                )
            }
        </>
    )
}
